import React, { Component } from 'react';
import styled from 'styled-components'
import  Header from './../../Resources/AppScreens/CommonComponents/Other/Navigation.svg';
import  Custom0 from './../../Resources/AppScreens/CommonComponents/Other/Interactive Musuem Map.svg';
import  Custom1 from './../../Resources/AppScreens/CommonComponents/Other/Exhibit Highlights.svg';
import  Custom2 from './../../Resources/AppScreens/CommonComponents/Other/Subtitle.svg';
import  Custom3 from './../../Resources/AppScreens/CommonComponents/Other/Two Buttons.svg';
import  Custom4 from "./../../Resources/AppScreens/CommonComponents/Other/Curator's Picks.svg";
import  Footer from './../../Resources/AppScreens/CommonComponents/Other/Bottom Navigation.svg';
import OtherComponents from '../../Resources/AppScreens/Preview-Features/Other';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 6px;
    &>* {
        margin-top: 5px;
    }
`;

const OtherPreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Custom0} />
        <img src={Custom1} />
        <img src={Custom2} style={{marginTop: "4px"}} />
        <img src={Custom3} />
        <img src={Custom4} />
        {features && features.map(feature => OtherComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%" }} />
</Container>);

export default OtherPreview;

